const NotamachineAlbumsStatic = () => {
    return (
      <>
        <div class="gallery_containerThree-static">  

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/7kNw1HCiOzeb4cNE5Njs7b?si=iJuDbqAHQS2tzGljBhrVJA" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e0213e5396fe4b85d93edfe0f4d" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>ideas, nowhere</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">Album</p>
            <a href="https://open.spotify.com/album/75gZfH0lOGsnPv7IrwINfk?si=HU-ygGh3T-mtzS33FAbE_w" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-AnihoskiLWTh2mdu-DJIdeg-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>             
              <p class="gallery-text">
              <strong>dreaming while swimming</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/1N9XqaHLj038krNySQsb8a?si=bgZsFrFbTmibW2S5n5DImg" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i1.sndcdn.com/artworks-RH61p4zyUz6bA5Yw-0pGeYQ-t500x500.png" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>dreaming while drowning</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/7GcJIGQDBnLb7SWU3Q2kXa?si=lIcpeNvOSPmxdqOfPYKrcw" target="_blank" rel="noopener noreferrer"> 
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e02e503f1aa754b23c993e3ab4a" width="100%" alt="" class="hover-zoom"/>
              </div>                
              <p class="gallery-text">
              <strong>whispers: 2.0</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/0Ln1UkRmJPp17HX1ShdAHc" target="_blank" rel="noopener noreferrer">    
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d00001e020f5bb9160e67d5b178b8e069" width="100%" alt="" class="hover-zoom"/>
              </div> 
              <p class="gallery-text">
              <strong>some remixes</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/13cL9Nd7P2yWXcOgBXU7Sh?si=yX9JkZKkSSCZkLSD_ghvRw" target="_blank" rel="noopener noreferrer">
            <div class="overflow-hidden">
              <img src="https://i.scdn.co/image/ab67616d00001e02b4005588bc8f2d1de3f3eb4d" width="100%" alt="" class="hover-zoom"/>
            </div>      
              <p class="gallery-text">
              <strong>birdsongs</strong><br/>
              </p>
            </a>
          </div>

        <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/4IjV5QTCpdBu5KgDW2Tj1a" target="_blank" rel="noopener noreferrer"> 
            <div class="overflow-hidden">
              <img src="https://i.scdn.co/image/ab67616d0000b27399e29f3e25ade7308f057c76" width="100%" alt="" class="hover-zoom"/>
            </div>  
              <p class="gallery-text">
              <strong>whispers: the beat tape</strong><br/>
              </p>
            </a>
          </div>

          <div class="gallery_item">
            <p class="gallery-tag">EP</p>
            <a href="https://open.spotify.com/album/6314rpaVlcpi7RITtdy7Ad" target="_blank" rel="noopener noreferrer">
              <div class="overflow-hidden">
                <img src="https://i.scdn.co/image/ab67616d0000b27334a304d134ddf7a087b707ca" width="100%" alt="" class="hover-zoom"/>
              </div>
              <p class="gallery-text">
                <strong>artificial</strong><br/>
              </p>
            </a>
          </div>

        </div>
      </>
    );
  };
  export default NotamachineAlbumsStatic;